import { render } from "./Informacoes.vue?vue&type=template&id=5f2f97b5&scoped=true"
import script from "./Informacoes.vue?vue&type=script&lang=js"
export * from "./Informacoes.vue?vue&type=script&lang=js"

import "./Informacoes.vue?vue&type=style&index=0&id=5f2f97b5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2f97b5"]])

export default __exports__